export const getType = (data, key) => {
  return data.find(value => {
    return key === value.key;
  }).name;
};
export const getCompany = (data, id) => {
  return data.find(value => {
    return id === value.id;
  }).companyInfo.qichacha_name;
};
